import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Pořadí',
    field: 'order',
    type: ColumnType.NUMBER,
    width: 200
  },
  {
    label: 'Název',
    field: 'name',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Aktivní',
    field: 'active',
    type: ColumnType.BOOLEAN,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-workDayTypes/_workDayTypesColumns.ts